import { DividerHorizontal } from './DividerHorizontal';
import { DividerVertical } from './DividerVertical';

export const Divider = {
  Horizontal: DividerHorizontal,
  Vertical: DividerVertical,
};
